<template>
  <!--会议日历-->
  <div id="myMeetingList">
    <div v-if="showPage">
      <div>
        <div class="metTopRed"></div>
        <div style="margin-top: -80px" class="p_r">
          <section class="canderInput">
            <section :id="randomId" class="canderDiv" v-if="showCalendar">
              <section class="canderHeader">
                <span class="c_p" @click="prevYear()"><b style="margin-right: -5px">＜</b><b>＜</b></span>
                <span class="c_p" @click="prevMonth()"><b>＜ </b></span>
                <span class="headerTitle"><b>{{nowYear}}年{{nowMonth}}月</b></span>
                <span class="c_p" @click="nextMonth()"><b>＞</b></span>
                <span class="c_p" @click="nextYear()"><b style="margin-right: -5px">＞</b><b>＞</b></span>
              </section>
              <section class="canderBody">
                <section><span>日</span><span>一</span><span>二</span><span>三</span><span>四</span><span>五</span><span>六</span></section>
                <section class="canderBodyDate">
                  <span @click="chooseDate(item, index)" :style="{'color': item.isLast? '#b8bcc5' : ''}" :class="returnChooseClass(item)" :key="index" v-for="(item, index) in dataTimeList">
                    <abbr>{{item.nowNum}}</abbr>
                    <p v-if="item.showImg === 1 && item.isImg"><img src="../../assets/warn01.png" height="20" width="20"/></p>
                    <p v-if="item.showImg === 2 && item.isImg"><img src="../../assets/warn02.png" height="20" width="20"/></p>
                    <p v-if="item.showImg === 3 && item.isImg"><img src="../../assets/warn03.png" height="20" width="20"/></p>
                  </span>
                </section>
                <div style="height: 20px;background-color: white;border-radius: 0 0 5px 5px"></div>
              </section>
            </section>
            <section v-else>
              <section class="canderHeader">
                <span class="headerTitle"><b>{{zMouth}}月</b></span>
              </section>
              <section class="weekDiv">
                <ul>
                  <li :class="item.isNow ? 'onWekli' : ''" :key="index" v-for="(item, index) in userForm" @click="seltWeek(item, index)">
                    <p>{{item.week}}</p>
                    <p>{{item.nowNum}}</p>
                    <div v-if="item.isImg">
                      <p v-if="item.showImg === 1"><img src="../../assets/warn01.png" height="20" width="20"/></p>
                      <p v-if="item.showImg === 2"><img src="../../assets/warn02.png" height="20" width="20"/></p>
                      <p v-if="item.showImg === 3"><img src="../../assets/warn03.png" height="20" width="20"/></p>
                    </div>
                  </li>
                </ul>
              </section>
            </section>
          </section>
          <span @click="toNow()" class="tdaiSpan" v-if="showCalendar">今</span>
          <span @click="seltCalen()" class="upSpan"> <abbr :style="{'transform': !showCalendar ? 'rotate(0deg)' : 'rotate(-180deg)'}"> <img src="../../assets/warn04.png" width="100%"/> </abbr></span>
        </div>
        <div v-if="!showBlogInfo" class="noBodyDiv">暂无数据</div>
        <div class="meetDiv" v-else>
          <nav>
            <span @click="meetNum = 1" :class="meetNum === 1 ? 'onMeetNavSpan' : ''">待参加会议</span>
            <span @click="meetNum = 2" :class="meetNum === 2 ? 'onMeetNavSpan' : ''">已结束会议</span>
          </nav>
          <div class="meetBody">
            <ul>
              <li v-if="parseInt(meetNum) === 1 && myMeetList.notStartMeetings.length > 0" :key="index" v-for="(item, index) in myMeetList.notStartMeetings">
                <div>
                  <p>{{ $commonJs.returnDate(item.beginTime, 'HHMMSS') }}</p>
                  <p>{{ $commonJs.returnDate(item.endTime, 'HHMMSS') }}</p>
                </div>
                <div></div>
                <div>
                  <p class="font16">{{ item.name }}</p>
                  <div class="t_r" v-if="showMeetBt"><span class="font16"><a :href="item.meetingUrl" style="color: white">参会</a></span></div>
                </div>
              </li>
              <li v-if="parseInt(meetNum) === 1 && myMeetList.notStartMeetings.length === 0" class="noBodyDiv" style="padding-top: 0">暂无数据</li>
              <li v-if="parseInt(meetNum) === 2 && myMeetList.finishedMeetings.length > 0" :key="index" v-for="(item, index) in myMeetList.finishedMeetings">
                <div>
                  <p>{{ $commonJs.returnDate(item.beginTime, 'HHMMSS') }}</p>
                  <p>{{ $commonJs.returnDate(item.endTime, 'HHMMSS') }}</p>
                </div>
                <div></div>
                <div>
                  <p class="font16">{{ item.name }}</p>
                  <div class="t_r" style="visibility: hidden"><span class="font16"><a :href="item.meetingUrl" style="color: white">参会</a></span></div>
                </div>
              </li>
              <li v-if="parseInt(meetNum) === 2 && myMeetList.finishedMeetings.length === 0" class="noBodyDiv" style="padding-top: 0">暂无数据</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--<div v-if="showGuide" class="guideTofollow"></div>-->
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import avatar from '@/assets/loading.gif'
import merge from 'webpack-merge';
import agreeBookDialog from "./agreeBookDialog";
export default {
  name: 'myMeetingList',
  data () {
    return {
      showBlogInfo: false,
      ABDialogShow:false,
      showCalendar: false,
      pushPlanTime: '',
      showPage: false,
      showGuide: false,
      redirectUrl: this.$route.query.redirectUrl,
      appid: this.$route.query.appid,
      openid: this.$route.query.openid,
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      chooseNowDate: '',
      chooseSelectDate: '',
      newDisabled: this.disabled,
      // newMinDate: this.minDate,
      randomId: 'cander' + new Date().getTime() + Math.random() * 1000,
      showCander: false,
      nowYear: 2019,
      nowMonth: 1,
      nowDate: new Date(),
      dataTimeList: [],
      newHour: '00',
      newMinite: '00',
      newDate: '00',
      myDate: '00',
      showImg: 1,
      userForm: [],
      weekList: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      docCode: '',
      meetingDate: '',
      myMeetList: {
        notStartMeetings: [],
        finishedMeetings: []
      },
      meetNum: 1,
      showMeetBt: true,
      zMouth: 1
    }
  },
  components: { agreeBookDialog },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myMeetingList?id=' + 0 + '&returnurl=' + (this.returnurl || ''))
      window.location.href = url
 }

     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myMeetingList?id=' + 0 + '&returnurl=' + (this.returnurl || ''))
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }

          if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true
                  this.replaceNewDate()
                  this.zMouth = new Date().getMonth() + 1
                  this.getWeekTime()
                  // 此处继续写方法判断是否有docCode
                  let data = {
                    openId: this.openId
                  }
                  this.$axiox.postNoRes('/Login/WxUserInfo', data).then(msg => {
                    console.log(msg)
                    this.docCode = msg.data.cdwD_DOCCode
                    if (this.docCode) {
                      let newYear = new Date().getFullYear()
                      let newMouth = new Date().getMonth() + 1
                      let newDay = new Date().getDate()
                      let newTody = newYear + '-' + newMouth + '-' + newDay
                      this.showBlogInfo = true
                      this.getHasMettingDate()
                      this.getMeetingsByDocCode(newTody)
                    } else {
                      this.showBlogInfo = false
                    }
                  })
                } else {
                  // this.$commonJs.closeWindow()
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }

        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}

        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {
            if (msg.data.status === 2) {
             //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                this.showPage = true
                this.replaceNewDate()
                this.zMouth = new Date().getMonth() + 1
                this.getWeekTime()
                // 此处继续写方法判断是否有docCode
                let data = {
                  openId: this.openId
                }
                this.$axiox.postNoRes('/Login/WxUserInfo', data).then(msg => {
                  console.log(msg)
                  this.docCode = msg.data.cdwD_DOCCode
                  if (this.docCode) {
                    let newYear = new Date().getFullYear()
                    let newMouth = new Date().getMonth() + 1
                    let newDay = new Date().getDate()
                    let newTody = newYear + '-' + newMouth + '-' + newDay
                    this.showBlogInfo = true
                    this.getHasMettingDate()
                    this.getMeetingsByDocCode(newTody)
                  } else {
                    this.showBlogInfo = false
                  }
                })
              } else {
                // this.$commonJs.closeWindow()
                this.showGuide = true
              }
            }
          }
        })
      }
    }
    // if (!this.$route.query.openid) {
    //   let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myMeetingList?id=' + 0 + '&returnurl=' + (this.returnurl || ''))
    //   window.location.href = url
    // } else {
    //   this.openId = this.$route.query.openid
    //   let isEmployee = window.localStorage.getItem('isEmployee')
    //   let requestUrl = ''
    //   if (isEmployee) {
    //     requestUrl = '/api/wechat/getEmployee/'
    //   } else {
    //     requestUrl = '/api/wechat/getDoctor/'
    //   }
    //   this.$axiox.getNoRes(process.env.config.baseUrl + requestUrl + this.openId + '?returnurl=' + encodeURIComponent(this.returnurl)).then(msg => {
    //     console.log(msg, 'getDoctor')
    //     if (msg.isSuccess) {
    //       if (msg.data.status === 2) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       } else if (msg.data.status === 3) {
    //         window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
    //       } else {
    //         if (msg.data.isFollowed) {
    //           this.showPage = true
    //           this.replaceNewDate()
    //           this.getWeekTime()
    //           // 此处继续写方法判断是否有docCode
    //           this.$axiox.getNoRes('/Login/WxUserInfo?openId=' + this.openId).then(msg => {
    //             console.log(msg)
    //             this.docCode = msg.data.cdwD_DOCCode
    //             if (this.docCode) {
    //               let newYear = new Date().getFullYear()
    //               let newMouth = new Date().getMonth() + 1
    //               let newDay = new Date().getDate()
    //               let newTody = newYear + '-' + newMouth + '-' + newDay
    //               this.showBlogInfo = true
    //               this.getHasMettingDate()
    //               this.getMeetingsByDocCode(newTody)
    //             } else {
    //               this.showBlogInfo = false
    //             }
    //           })
    //         } else {
    //           // this.$commonJs.closeWindow()
    //           this.showGuide = true
    //         }
    //       }
    //     }
    //   })
    // }

    setTimeout(() => {
    this.getSignDetail();
    this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
    }, 1000);


  },
  mounted () {
    let that = this
    this.$nextTick(() => {
      let iframe = document.getElementById('myMeetingList')
      // console.log(iframe, 'myForm')
      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          that.disCover()
          that.showPage = true
        })
      } else {
        iframe.onload = function () {
          that.disCover()
          that.showPage = true
        }
      }
    })
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    returnChooseClass (item) {
      if (item.isNow && item.isChoose) {
        item.showImg = 1
        return 'chooseDay'
      } else {
        if (item.isNow) {
          item.showImg = 2
          return 'nowDay'
        } else if (item.isChoose) {
          item.showImg = 1
          return 'chooseDay'
        }
      }
    },
    toNow () {
      this.nowYear = new Date().getFullYear()
      this.nowMonth = new Date().getMonth() + 1
      for (let i = 0; i < this.dataTimeList.length; i++) {
        this.dataTimeList[i].isNow = false
        if (new Date().getFullYear() === new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getFullYear() && new Date().getMonth() + 1 === new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getMonth() + 1 && new Date().getDate() === new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getDate()) {
          this.dataTimeList[i].isNow = true
        }
      }
      this.replaceNewDate(this.nowYear + '-' + this.nowMonth + '-' + new Date().getDate())
      if (this.showBlogInfo) {
        this.getHasMettingDate()
        this.meetNum = 1
        let newYear = new Date().getFullYear()
        let newMouth = new Date().getMonth() + 1
        let newDay = new Date().getDate()
        let newTody = newYear + '-' + newMouth + '-' + newDay
        this.getMeetingsByDocCode(newTody)
      }
      // console.log(this.dataTimeList)
    },
    chooseDate (item, index) {
      let seltMonth = new Date(item.nowDate.replace(/-/g, '/')).getMonth() + 1
      // console.log(item.nowDate)
      // console.log(parseInt(this.nowMonth))
      if (parseInt(seltMonth) === parseInt(this.nowMonth)) {
        for (let i = 0; i < this.dataTimeList.length; i++) {
          this.dataTimeList[i].isNow = false
          this.dataTimeList[i].showImg = 1
          if (new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1) {
            this.dataTimeList[i].showImg = 3
          }
        }
        this.dataTimeList[index].isNow = true
        this.dataTimeList[index].showImg = 2
        this.meetNum = 1
        this.showMeetBt = !(new Date(item.nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1)
        this.getMeetingsByDocCode(item.nowDate)
      }
    },
    prevMonth () {
      let year = this.nowDate.getFullYear()
      let month = this.nowDate.getMonth()
      month = month === 0 ? 12 : month
      year = month === 12 ? year - 1 : year
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '-' + month + '-' + date)
      if (this.showBlogInfo) {
        this.getHasMettingDate()
        this.meetNum = 1
        this.myMeetList = {
          notStartMeetings: [],
          finishedMeetings: []
        }
        if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === date) {
          let newYear = new Date().getFullYear()
          let newMouth = new Date().getMonth() + 1
          let newDay = new Date().getDate()
          let newTody = newYear + '-' + newMouth + '-' + newDay
          this.getMeetingsByDocCode(newTody)
        }
      }
    },
    nextMonth () {
      let year = this.nowDate.getFullYear()
      let month = this.nowDate.getMonth() + 2
      month = month === 13 ? 1 : month
      year = month === 1 ? year + 1 : year
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '-' + month + '-' + date)
      if (this.showBlogInfo) {
        this.getHasMettingDate()
        this.meetNum = 1
        this.myMeetList = {
          notStartMeetings: [],
          finishedMeetings: []
        }
        if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === date) {
          let newYear = new Date().getFullYear()
          let newMouth = new Date().getMonth() + 1
          let newDay = new Date().getDate()
          let newTody = newYear + '-' + newMouth + '-' + newDay
          this.getMeetingsByDocCode(newTody)
        }
      }
    },
    prevYear () {
      const year = this.nowDate.getFullYear() - 1
      const month = this.nowDate.getMonth() + 1
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '-' + month + '-' + date)
      if (this.showBlogInfo) {
        this.getHasMettingDate()
        this.meetNum = 1
        this.myMeetList = {
          notStartMeetings: [],
          finishedMeetings: []
        }
        if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === date) {
          let newYear = new Date().getFullYear()
          let newMouth = new Date().getMonth() + 1
          let newDay = new Date().getDate()
          let newTody = newYear + '-' + newMouth + '-' + newDay
          this.getMeetingsByDocCode(newTody)
        }
      }
    },
    nextYear () {
      const year = this.nowDate.getFullYear() + 1
      const month = this.nowDate.getMonth() + 1
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '-' + month + '-' + date)
      if (this.showBlogInfo) {
        this.getHasMettingDate()
        this.meetNum = 1
        this.myMeetList = {
          notStartMeetings: [],
          finishedMeetings: []
        }
        if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === date) {
          let newYear = new Date().getFullYear()
          let newMouth = new Date().getMonth() + 1
          let newDay = new Date().getDate()
          let newTody = newYear + '-' + newMouth + '-' + newDay
          this.getMeetingsByDocCode(newTody)
        }
      }
    },
    replaceNewDate (date) {
      this.chooseNowDate = ''
      this.dataTimeList = []
      let nowDate = new Date()
      if (date) {
        nowDate = new Date(date.replace(/-/g, '/'))
      }
      this.nowDate = nowDate
      const year = nowDate.getFullYear()
      const month = nowDate.getMonth() + 1
      // const day = nowDate.getDate()
      this.nowYear = year
      // this.nowMonth = month < 10 ? '0' + month : month
      this.nowMonth = month
      const week = new Date(year + '/' + month + '/' + 1).getDay()
      let num = 1
      let lastNum = 1
      this.myDate = this.returnMaxMonth(year, month)
      // console.log(this.returnMaxMonth(year, month))
      // console.log(year, month)
      for (let i = 0; i < 42; i++) {
        let data = {
          nowNum: '',
          nowDate: '',
          isNow: false,
          isLast: false,
          disabled: false,
          showImg: 1,
          isImg: false
        }
        if (i < week) {
          data.isLast = true
          if (month === 1) {
            data.nowDate = (year - 1) + '-' + 12 + '-' + (this.returnMaxMonth(year - 1, 12) - week + i + 1)
            data.nowNum = this.returnMaxMonth(year - 1, 12) - week + i + 1
          } else {
            data.nowDate = year + '-' + (month - 1) + '-' + (this.returnMaxMonth(year, month - 1) - week + i + 1)
            data.nowNum = this.returnMaxMonth(year, month - 1) - week + i + 1
          }
        } else if (num > this.returnMaxMonth(year, month)) {
          data.isLast = true
          if (month === 12) {
            data.nowDate = (year + 1) + '-' + 1 + '-' + lastNum
            data.nowNum = lastNum
          } else {
            data.nowDate = year + '-' + (month + 1) + '-' + lastNum
            data.nowNum = lastNum
          }
          lastNum++
        } else {
          data.nowDate = year + '-' + month + '-' + num
          data.nowNum = num
          if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === num) {
            data.isNow = true
          }
          num++
        }
        if (new Date(data.nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1) {
          data.showImg = 3
        }
        this.dataTimeList.push(data)
      }
      console.log(this.dataTimeList)
      // let fistDate = this.nowYear + '-' + this.nowMonth + '-01'
      // let lastDate = this.nowYear + '-' + this.nowMonth + '-' + this.myDate
      // this.getAllList(fistDate, lastDate)
    },
    returnMaxMonth (year, month) {
      if ([1, 3, 5, 7, 8, 10, 12].indexOf(month) >= 0) {
        return 31
      }
      if ([4, 6, 9, 11].indexOf(month) >= 0) {
        return 30
      }
      if (month === 2) {
        if (year % 4 === 0) {
          return 29
        } else {
          return 28
        }
      }
    },
    // 获取一周
    getWeekTime () {
      this.userForm = []
      var currentFirstDate
      var formatDate = function (date) {
        var year = date.getFullYear() + '/'
        var month = date.getMonth() + 1 + '/'
        var day = date.getDate()
        return year + month + day
      }

      var addDate = function (date, n) {
        date.setDate(date.getDate() + n)
        return date
      }
      var setDate = function (date) {
        var week = date.getDay() - 1
        date = addDate(date, week * -1)
        currentFirstDate = new Date(date)
        var arr = []
        for (var i = 0; i < 7; i++) {
          var a = formatDate(i === 0 ? date : addDate(date, 1)) // 星期一开始
          arr.push(a)
        }
        return arr
      }
      setDate(new Date())
      var num = 0 // num为0时表示当前周，递增或递减时周数也递增或递减
      // return setDate(addDate(currentFirstDate, 7 * num));
      let setWeek = setDate(addDate(currentFirstDate, 7 * num))
      // this.userForm.TimeChoose.push(setWeek[0], setWeek[6]);
      for (let i = 0; i < setWeek.length; i++) {
        let data = {
          nowNum: '',
          nowDate: '',
          isNow: false,
          isLast: false,
          disabled: false,
          showImg: 1,
          week: '',
          isImg: false
        }
        data.nowNum = new Date(setWeek[i]).getDate()
        data.nowDate = setWeek[i]
        data.week = this.weekList[i]
        if (new Date().getFullYear() === new Date(data.nowDate.replace(/-/g, '/')).getFullYear() && new Date().getMonth() + 1 === new Date(data.nowDate.replace(/-/g, '/')).getMonth() + 1 && new Date().getDate() === new Date(data.nowDate.replace(/-/g, '/')).getDate()) {
          data.isNow = true
          data.showImg = 2
        }
        if (new Date(data.nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1) {
          data.showImg = 3
        }
        this.userForm.push(data)
      }
      // this.userForm = [setWeek[0], setWeek[6]]
      console.log(this.userForm)
    },
    seltWeek (item, index) {
      this.zMouth = new Date(item.nowDate.replace(/-/g, '/')).getMonth() + 1
      for (let i = 0; i < this.userForm.length; i++) {
        this.userForm[i].isNow = false
        this.userForm[i].showImg = 1
        if (new Date(this.userForm[i].nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1) {
          this.userForm[i].showImg = 3
        }
      }
      this.userForm[index].isNow = true
      this.userForm[index].showImg = 2
      this.meetNum = 1
      this.showMeetBt = !(new Date(item.nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1)
      this.getMeetingsByDocCode(item.nowDate)
    },
    seltCalen () {
      this.showCalendar = !this.showCalendar
      if (this.showCalendar) {
        this.nowYear = new Date().getFullYear()
        this.nowMonth = new Date().getMonth() + 1
        for (let i = 0; i < this.dataTimeList.length; i++) {
          this.dataTimeList[i].isNow = false
          this.dataTimeList[i].showImg = 1
          if (new Date().getFullYear() === new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getFullYear() && new Date().getMonth() + 1 === new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getMonth() + 1 && new Date().getDate() === new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getDate()) {
            this.dataTimeList[i].isNow = true
            this.dataTimeList[i].showImg = 2
          }
          if (new Date(this.dataTimeList[i].nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1) {
            this.dataTimeList[i].showImg = 3
          }
        }
        this.replaceNewDate(this.nowYear + '-' + this.nowMonth + '-' + new Date().getDate())
      } else {
        for (let i = 0; i < this.userForm.length; i++) {
          this.userForm[i].isNow = false
          this.userForm[i].showImg = 1
          if (new Date().getFullYear() === new Date(this.userForm[i].nowDate.replace(/-/g, '/')).getFullYear() && new Date().getMonth() + 1 === new Date(this.userForm[i].nowDate.replace(/-/g, '/')).getMonth() + 1 && new Date().getDate() === new Date(this.userForm[i].nowDate.replace(/-/g, '/')).getDate()) {
            this.userForm[i].isNow = true
            this.userForm[i].showImg = 2
          }
          if (new Date(this.userForm[i].nowDate.replace(/-/g, '/')).getTime() < new Date().getTime() - (24 * 60 * 60 * 1000) + 1) {
            this.userForm[i].showImg = 3
          }
          this.zMouth = new Date(this.userForm[i].nowDate.replace(/-/g, '/')).getMonth() + 1
        }
      }
      this.meetNum = 1
      let newYear = new Date().getFullYear()
      let newMouth = new Date().getMonth() + 1
      let newDay = new Date().getDate()
      let newTody = newYear + '-' + newMouth + '-' + newDay
      this.$nextTick(p => {
        this.getMeetingsByDocCode(newTody)
        if (this.showCalendar) {
          this.getHasMettingDate()
        }
      })
    },
    // 获取会议日程
    getHasMettingDate () {
      this.$axiox.get('/api/meeting/GetHasMettingDate?docCode=' + this.docCode + '&openid=' + (this.openid || localStorage.openId)).then(msg => {
        for (let i = 0; i < msg.length; i++) {
          for (let j = 0; j < this.dataTimeList.length; j++) {
            if (new Date(msg[i].replace(/-/g, '/')).getDate() === new Date(this.dataTimeList[j].nowDate.replace(/-/g, '/')).getDate() && new Date(msg[i]).getMonth() === new Date(this.dataTimeList[j].nowDate.replace(/-/g, '/')).getMonth() && new Date(msg[i]).getFullYear() === new Date(this.dataTimeList[j].nowDate.replace(/-/g, '/')).getFullYear()) {
              this.dataTimeList[j].isImg = true
            }
          }
          for (let j = 0; j < this.userForm.length; j++) {
            if (new Date(msg[i].replace(/-/g, '/')).getDate() === new Date(this.userForm[j].nowDate.replace(/-/g, '/')).getDate() && new Date(msg[i]).getMonth() === new Date(this.userForm[j].nowDate.replace(/-/g, '/')).getMonth() && new Date(msg[i]).getFullYear() === new Date(this.userForm[j].nowDate.replace(/-/g, '/')).getFullYear()) {
              this.userForm[j].isImg = true
            }
          }
        }
      })
    },
    // 获取当天会议信息
    getMeetingsByDocCode (type) {
      this.$axiox.get('/api/meeting/GetMeetingsByDocCodeOrOpenid?docCode=' + this.docCode + '&meetingDate=' + type + '&openid=' + (this.openid || localStorage.openId)).then(msg => {
        this.myMeetList.notStartMeetings = msg.notStartMeetings || []
        this.myMeetList.finishedMeetings = msg.finishedMeetings || []
      })
    },
    // Loading
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  }
}
</script>

<style scoped>
.canderInput {
  width: 88%;
  margin:0 auto;
}
.canderHeader {
  text-align: center;
  font-size: 20px;
  padding: 10px;
  background: transparent;
  color: white;
}
.headerTitle {
  margin: 0 20px;
}
.canderBody {
  border-radius: 5px;
  box-shadow: 0 4px 5px 2px #e8e8e8;
}
.canderBody section:first-child {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #4A535D;
  padding: 10px 0;
  border-radius: 5px 5px 0 0;
  background-color: white;
}
.canderBodyDate {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  /*border-radius: 0 0 5px 5px;*/
}
.canderBodyDate span {
  flex: 1;
  width: 10.2%;
  min-width: 5.2%;
  max-width: 5.2%;
  text-align: center;
  height: 40px;
  /*border-right: 1px solid #E3EBEE;*/
  /*border-bottom: 1px solid #E3EBEE;*/
  display: inline-block;
  margin: 5px 12px;
  padding: 2px;
}
.canderBodyDate span:nth-child(7n) {
  border-right: none;
}
.canderBodyDate span abbr {
  display: block;
  padding: 2px 0;
}
.canderBodyDate span p {
  /*padding: 10px;*/
  text-align: center;
}
.spanBack_color {
  background-color: #ECFFF8;
}
.spanBack_colorFDF3BE abbr {
  background-color: #FDF3BE;
}
.spanBack_colorFDF3BE p {
  background-color: #FBB321;
  color: white;
}
.spanBack_colorF4F8F9 abbr {
  background-color: #F4F8F9;
}
.spanBack_colorF4F8F9 p {
  background-color: #C4C4C4;
  color: white;
}
.spanBack_colorFFE1D8 abbr {
  background-color: #FFE1D8;
}
.spanBack_colorFFE1D8 p {
  background-color: #FF4F18;
  color: white;
}
.canderBodyDate span.nowDay {
  background: #ff4c4f!important;
  border-radius: 100px 100px;
  box-shadow: 0 0 2px 3px #ff4c4f;
  color: #fff;
}
.canderBodyDate span.chooseDay {
  background: #FF8144!important;
  color: #fff;
}
.weekDiv {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 4px 5px 2px #e8e8e8;
}
.weekDiv ul {
  padding: 10px 20px 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}
.weekDiv ul li {
  padding: 2px;
}
.weekDiv ul li > p:nth-child(2) {
  padding: 2px 0;
}
.onWekli {
  background: #ff4c4f!important;
  border-radius: 100px 100px;
  box-shadow: 0 0 2px 3px #ff4c4f;
  color: #fff;
}
.noBodyDiv {
  /*height: 100vh;*/
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  /*font-weight: bold;*/
  /*color: red;*/
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/myMeetingList.vue